import debouce from 'lodash.debounce'
import { useCallback, useEffect, useState, useMemo } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
// Redux
import { useDispatch, useSelector } from 'react-redux';
import actions from 'store/actions';
// Packages
import Splide from '@splidejs/splide';
import Masonry, {ResponsiveMasonry} from "react-responsive-masonry"
// Utils
import { checkImageUrl, formatCurrency, inputChange } from 'utils/modules/Handlers';
// Components
import Icons from 'components/Icons';
import Separator from 'components/Separator';
import RequestStepper from 'components/RequestStepper';
import Footer from 'components/Footer';
// Assets
import './showingBeeAgent.scss';
import NoUser from 'assets/images/no_user.jpg'
import PageWrapper from 'components/PageWrapper';
import CustomContainer from 'components/CustomContainer';
import ProfileCard from 'components/ProfileCard';
import CustomButton from 'components/CustomButton';

const ShowingBeeAgent = () => {
    const { id: listingID, mls } = useParams();
    const urlParams = new URLSearchParams(window.location.search);
    const {featuredAgents: myAgents } = useSelector((state) => state.agent)
    const { showing } = useSelector((state) => state.showing)
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [load, setLoad] = useState(false);
    const compensation_type = ['All', 'Cash', 'Percent']
    const [filters, setFilters] = useState({
        compensation_type: {
            value: 'All',
        },
        minimum_amount: {
            value: '',
        },
        maximum_amount: {
            value: '',
        },
    })

    const onSearch = useCallback(async() => {
        const { compensation_type, minimum_amount, maximum_amount } = filters
        let filterString = []
        if (compensation_type.value !== 'All') {
            if (compensation_type.value) filterString.push(`compensation_type=${compensation_type.value.toLowerCase()}`)
            if (minimum_amount.value) filterString.push(`minimum_amount=${minimum_amount.value}`)
            if (maximum_amount.value) filterString.push(`maximum_amount=${maximum_amount.value}`)
        }
        setLoad(true);
        try {
            await dispatch(actions.agent.fetchFeaturedAgents({ filters: filterString.join('&') })).then(() => {
                setLoad(false);
            });
        } catch (error) {
            setLoad(false);
            console.log(error)
        }
    }, [filters])

    useEffect(() => {
        onSearch();
    }, [filters])

    useEffect(() => {
        const init = async() => {
            const id = localStorage.getItem("showingId")
            await dispatch(actions.showing.retrieveShowing(id)) 
        }
        init();
    }, [dispatch])

    const onSelectAgent = async(agent, showing) => {
        const body = {
            showing: showing.id,
            buyer_agent: agent.id,
        }
        await dispatch(actions.showing.showingRequestStep2Agent(body))
        navigate(`/request/${mls}/${listingID}/${urlParams.get('next')}`)
    }

    const onTypeChange = (item) => {
        if (item === 'All') {
            document.getElementById('minimum_amount').value = ''
            document.getElementById('maximum_amount').value = ''
            setFilters({
                compensation_type: {
                    value: 'All',
                },
                minimum_amount: {
                    value: '',
                },
                maximum_amount: {
                    value: '',
                },
            })
        } else {
            inputChange({ setForm: setFilters, key: 'compensation_type', value: 'value', data: item })
        }
    }
    const onChangeInput = (event) => {
        inputChange({ setForm: setFilters, key: event.target.name, value: 'value', data: event.target.value })
    }

    const handleInput = useMemo(() => {
        return debouce(onChangeInput, 100)
    }, [filters])

    return (
        <PageWrapper>
            <CustomContainer>
                <div className="featured-agents-container">
                    <div className='header'>
                        <p className='back-button' onClick={() => navigate(`/request/${mls}/${listingID}/choose-agent/?prev=${urlParams.get('prev')}&next=${urlParams.get('next')}`)}>Cancel</p>
                        <p style={{ fontSize: 20, fontWeight: 700 }}>Showing Bee Agents</p>
                        <p style={{ fontSize: 16, fontWeight: 400, color: '#5F5F5F' }}>Select Showing Bee Agents for you.</p>
                    </div>
                        {/* <div className="filters">
                            <div className='contents'>
                                <div className='filter-block'>
                                    <div className='header'>
                                        <Icons.Compensation color={'#FAC91F'} />
                                        <p>Compensation Type</p>
                                    </div>
                                    <div className='type-choices'>
                                        {
                                            compensation_type.map((item, index) => {
                                                return ( 
                                                <div 
                                                    key={index}
                                                    className={`choice ${filters.compensation_type.value === item && 'selected'}`}
                                                    onClick={(event) => onTypeChange(item)}
                                                >
                                                <p>{item}</p>
                                                </div> )
                                            })
                                        }
                                    </div>
                                </div>
                                <Separator width={20} />
                                <div className='filter-block'>
                                    <div className='header'>
                                        <Icons.CompensationAmount color={'#FAC91F'} />
                                        <p>Compensation Amount</p>
                                    </div>
                                    <Separator height={10} />
                                    <div className='max-min-input'>
                                        <input id="minimum_amount" name='minimum_amount' type="text" onChange={handleInput} placeholder="Min" disabled={filters.compensation_type.value === 'All'} />
                                        <p className='separator'>to</p>
                                        <input id="maximum_amount" name='maximum_amount' type="text" onChange={handleInput} placeholder="Max" disabled={filters.compensation_type.value === 'All'}/>
                                    </div>
                                </div>
                            </div>
                        </div> */}
                    <div className="agents">
                        {
                            !load
                            ? <div className='contents'>
                            {
                                myAgents.length > 0 
                                ? <ResponsiveMasonry
                                    columnsCountBreakPoints={{350: 1, 750: 2, 900: myAgents.length > 3 ? 4 : 3}}
                                    style={{ padding: '0 58px' }}
                                >
                                    <Masonry gutter={'24px'}>
                                    { 
                                        myAgents.map((agent, index) => (
                                            <ProfileCard data={agent} type='ba' key={index}>
                                                <CustomButton
                                                    text='Select Agent'
                                                    style={{ width: '100%', alignSelf: 'center' }}
                                                    type='secondary'
                                                    size='small'
                                                    action={() => onSelectAgent(agent, showing)}
                                                />
                                            </ProfileCard>

                                            
                                        ))
                                    }
                                    </Masonry>
                                </ResponsiveMasonry>
                                : <p className='no-result'>No Featured Agent Available</p>
                            }
                            </div>
                            : <div className='contents'>
                                <div className="loader">
                                    <Icons.Loading background={'none'} height={100} width={100} />
                                </div>
                            </div>
                        }
                    </div>
                </div>
            </CustomContainer>
        </PageWrapper>
    )
}


export default ShowingBeeAgent;